module.exports = __webpack_public_path__ + "static/media/5DPO12.f5ea87f5.jpg";